<template>
    <b-row dir="ltr" v-if="totalRows !== 0">
        <b-col v-if="pageOptions" sm="7" md="6" class="my-1">
            <b-pagination
                v-model="page"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
                @change="pageChangedHandler"
            >
            </b-pagination>
        </b-col>
        <b-col v-if="pageOptions" align="right" class="mr-2">
            <b-form-group
                >{{ $t('Shared.Show') }}
                <b-form-select
                    v-model="paginatorPerPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                    style="width:auto;"
                    @change="pageSizeHandler"
                ></b-form-select>
                {{ $t('Shared.Of') }} {{ totalRows }}
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
export default {
    name: 'EditablePaginator',
    props: {
        perPage: {
            type: Number,
            default: 10
        },
        pageChanged: Function,
        perPageFunction: Function,
        pageOptions: {
            type: Array,
            default: () => [5, 10, 15]
        },
        totalRows: {
            type: Number,
            default: 0
        },
        currentPage: {
            type: Number,
            default: 1
        }
    },
    data() {
        return {
            page: 1,
            paginatorPerPage: this.perPage
        };
    },
    watch: {
        currentPage(newValue) {
            this.$nextTick(() => (this.page = newValue));
        },
        perPage(newValue) {
            this.$nextTick(() => (this.paginatorPerPage = newValue));
        }
    },
    methods: {
        pageSizeHandler(perPage) {
            this.perPageFunction(perPage);
        },

        pageChangedHandler(page) {
            this.pageChanged(page);
        }
    }
};
</script>
